import React from "react";
import { CURRENCIES } from "../utils/constants";
import "./styles/CurrencySelect.css";

/**
 * F4 — currency switcher (USD/EUR/GBP/INR/JPY), persisted by App.
 */
export default function CurrencySelect({ value, onChange }) {
  return (
    <label className="currency-select">
      <span className="visually-hidden">Currency</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Select display currency"
        data-testid="currency-select"
      >
        {CURRENCIES.map((c) => (
          <option key={c.code} value={c.code}>
            {c.symbol} {c.label}
          </option>
        ))}
      </select>
    </label>
  );
}
